import { render, staticRenderFns } from "./AssetTypeCategories.vue?vue&type=template&id=44661d5e"
import script from "./AssetTypeCategories.vue?vue&type=script&lang=js"
export * from "./AssetTypeCategories.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeCategories.vue?vue&type=style&index=0&id=44661d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports